module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班级名称",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.form.ClassName),
      callback: function($$v) {
        _vm.$set(_vm.form, "ClassName", $$v)
      },
      expression: "form.ClassName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级年段",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "formlength",
    attrs: {
      "placeholder": "-请选择-"
    },
    model: {
      value: (_vm.form.Grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "Grade", $$v)
      },
      expression: "form.Grade"
    }
  }, _vm._l((_vm.classType), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.id,
        "label": option.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班主任姓名"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.form.MainTeacherName),
      callback: function($$v) {
        _vm.$set(_vm.form, "MainTeacherName", $$v)
      },
      expression: "form.MainTeacherName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班主任手机号"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.form.MainTeacherPhone),
      callback: function($$v) {
        _vm.$set(_vm.form, "MainTeacherPhone", $$v)
      },
      expression: "form.MainTeacherPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary ",
      "size": "samll "
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20e1e444!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/addClass/index.vue
// module id = 1416
// module chunks = 1